module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1175.58c0a52d.png";